module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"maxVacanciesTitleCopy":"You cannot copy the job","vacancy":"Job","city":"City","candidates":"Candidates","interview":"Interviews","expires":"Expires","noData":"No data","testing":"Testing","creator":"Creator","newVacancy":"New job"}}')
  delete Component.options._Ctor
}
